import { Grid } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { createTheme, styled } from '@mui/material/styles';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#ddb930',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const HeaderBar = styled(AppBar)(({ theme }) => ({
  position: 'relative',
  height: 'fit-content',
  paddingBottom: '10px',
  color: 'primary',
  top: '0px',
  boxShadow: 'none',
  zIndex: 0,
  justifyContent: 'start',
  marginBottom: '3rem',
}));

const Layer1 = styled(Grid)(({ theme }) => ({
  position: 'absolute',
  bottom: '-50px',
  left: '0px',
  width: '100%',
  height: '300px',
  padding: '0 5rem',
  [theme.breakpoints.down('md')]: {
    padding: '0 2rem',
  },
}));

const ParaText = styled('div')(({ theme }) => ({
  fontSize: '1rem',
  color: '#ffffff',
  backgroundColor: "#4c4a5b",
  borderRadius: "10px",
  padding: "2%"
}));

const TabsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(255,255,255,0.1)',
  padding: '5px',
  borderRadius: '20px',
  width: 'fit-content',
}));

const ProfileImg = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  width: '250px',
  height: '250px',
  borderRadius: '50%',
  zIndex: '2',
  border: '10px solid #3b394e',
  [theme.breakpoints.down('md')]: {
    width: '150px',
    height: '150px',
  },
}));

const Indicator = styled('div', {
  shouldForwardProp: prop => prop !== 'hidden',
})(({ theme, hidden, color }) => ({
  width: '28px',
  height: '28px',
  borderRadius: '10px',
  background: color ? color :'#ddb930',
  color: color ? "black" : "white",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: '10px',
  opacity: hidden ? 0 : 1,
}));

const BackgroundBox = styled(Box)(({ theme }) => ({
  height: '40vh',

  [theme.breakpoints.down('xl')]: {
    height: '45vh',
  },
}));

export {
  colortheme,
  BackgroundBox,
  Indicator,
  ProfileImg,
  TabsWrapper,
  ParaText,
  Layer1,
  HeaderBar,
};
